// Form steps
export const AUDIENCE = 'audience';
export const EMAIL = 'email';
export const SMS = 'sms';
export const REVIEW = 'review';

export const BOTH = 'both';
export const SUBJECT_LIMIT = 80;
export const AUTOSAVE_TIMER = 10000;

export const ERROR = 'error';

export const SCHEDULED = 'scheduled';

// Statuses
export const FREE = 'free';
export const PAID = 'paid';
export const DRAFT = 'draft';

export const MMS_CHAR_LIMIT = 320;

export const columns = [
  {
    title: 'Type',
    sortable: true,
    width: '65px',
    padding: '0 16px 0 24px',
    sortLocation: 'left',
    columnName: 'broadcastType',
  },
  {
    title: 'Content Preview',
    width: '140px',
    padding: '0 24px 0 0',
    sortable: true,
    sortLocation: 'left',
    columnName: 'contentPreview',
  },
  {
    title: 'Date',
    width: '130px',
    padding: '0 24px 0 0',
    sortable: true,
    sortLocation: 'left',
    columnName: 'sentAt',
  },
  {
    title: 'Status',
    width: '70px',
    padding: '0 24px 0 0',
    sortable: true,
    sortLocation: 'left',
    columnName: 'status',
  },
  {
    title: 'Audience Name',
    width: '130px',
    padding: '0 24px 0 0',
    sortable: false,
    sortLocation: 'left',
    columnName: 'audienceNames',
  },
  {
    title: 'Audience Count',
    width: '70px',
    padding: '0 24px 0 0',
    sortable: true,
    sortLocation: 'left',
    columnName: 'totalAudience',
  },
  {
    title: '',
    width: '30px',
    padding: '0 16px 0 0',
    sortable: false,
    sortLocation: 'left',
    columnName: 'actions',
  },
];
